import { render, staticRenderFns } from "./titleCountSpentProducts.vue?vue&type=template&id=2bd5edb8&"
import script from "./titleCountSpentProducts.vue?vue&type=script&lang=js&"
export * from "./titleCountSpentProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports